import { Box, styled } from "@mui/material";

/**
 * Shared max width for the chat message column AND the composer. Both must use
 * this so the input lines up under the messages on every surface (main AA page,
 * projects chat, product chats). Width stays fluid (`width: 100%`) below it.
 */
export const CHAT_COLUMN_MAX_WIDTH = "900px";

// ChatWrapperContainer: Wraps the ChatContainer, managing padding, scrolling, and layout within the page.
export const ChatWrapperContainer = styled(Box)(({}) => ({
  padding: "10px",
  paddingTop: "8px",
  overflowY: "auto",
  height: "100%",
  justifyContent: "center",
  position: "relative",
  flex: 1,
  backgroundColor: "#FCFCF9",
}));

// ChatMainContainer: Main container for the chat interface, ensuring content is centered and scrollable.
export const ChatMainContainer = styled(Box)(({}) => ({
  overflowY: "hidden",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

// ChatScroller: Scrollable container for chat messages, handling overflow and alignment.
export const ChatScroller = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  flexDirection: "column",
  alignItems: "center",
  overflowX: "hidden",
  overflowY: "scroll",
  overflowAnchor: "auto",
  flex: 1,
  position: "relative",
  height: "100%",
  // Custom scrollbar styling
  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: theme.palette.grey[300],
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: theme.palette.grey[500],
  },
}));

// PromptContainer: Holds the input area for typing new messages, ensuring it is positioned correctly.
export const PromptContainer = styled(Box)(({}) => ({
  position: "relative",
  maxWidth: CHAT_COLUMN_MAX_WIDTH,
  width: "100%",
  alignSelf: "center",
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
  "&::before": {
    content: '""',
    position: "absolute",
    bottom: 0,
    insetInlineStart: 0,
    width: "100%",
  },
}));

// ChatActionsContainer: Container for chat action buttons, aligned to the bottom right.
export const ChatActionsContainer = styled(Box)(({}) => ({
  display: "flex",
  alignSelf: "flex-end",
  marginBottom: 8,
}));
